"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const locales_1 = require("../locales");
locales_1.loadLocaleData([
    "en-US",
    "en-GB",
    "en-ZA",
    "en-NZ",
    "en-AU",
    "es-MX",
    "fr-CA",
    "fr-FR",
    "ja-JP",
    "en-QT"
]);
//# sourceMappingURL=loadLocaleData.js.map